module.exports = __webpack_public_path__ + "img/flamethrower-turret-gun-extension-shadow.d78ffac1.png";